const STAGING = "staging";
const DEV = "dev";
const PROD = "production";

export const featureNames = {
  FEEDBACK: "FEEDBACK",
};

export const isFeatureEnabled = (feature) =>
  ({
    [featureNames.FEEDBACK]: [DEV, STAGING, PROD],
  }[feature].includes(process.env.REACT_APP_ENV));
